import React, { useEffect, useState } from "react";
import _, { isEmpty } from "lodash";
import i18n from "../i18n";
import "./styles/checkbox.css";

const Highlighted = ({
  text = "",
  highlight = "",
  hasLink,
  postId,
  publishStatus,
  isDirty,
  handleDirtyPrompt,
  title = "",
}) => {
  const [redirect, setRedirect] = useState(false);

  const editedTxt = text;

  const handleLinkClick = (event) => {
    event.preventDefault();

    if (isDirty) {
      handleDirtyPrompt(hasLink);
    } else {
      setRedirect(true);
    }
  };

  useEffect(() => {
    if (redirect && !isDirty) {
      const lang = JSON.parse(localStorage.getItem("user")).lang;
      let navigateToArchieve = false;
      if (
        title === "Archived Post Republished" ||
        title === "Irrelevant Post Deleted" ||
        title === "存档帖子已重新发布" ||
        title === "不相关帖子删除" ||
        title === "不相關帖子刪除" ||
        title === "存檔帖子已重新發布"
      ) {
        navigateToArchieve = true;
      }
      if (navigateToArchieve) {
        window.location.href = `/forum/archive/${hasLink}`;
      } else {
        window.location.href = `/forum/post/${hasLink}`;
      }
    }
  }, [redirect, isDirty, hasLink]);

  // Space-preserving highlighter
  const applyHighlighting = (rawText) => {
    const hay = String(rawText || "");
    const needle = highlight != null ? String(highlight) : "";

    // If empty string: render plain (but preserve spaces/newlines)
    if (needle === "") {
      return <span style={{ whiteSpace: "pre-wrap" }}>{hay}</span>;
    }

    try {
      const re = new RegExp(_.escapeRegExp(needle), "gi");
      const out = [];
      let last = 0;
      let m;

      while ((m = re.exec(hay)) !== null) {
        if (m.index > last) out.push(hay.slice(last, m.index));
        out.push(
          <mark key={last} style={{ padding: 0, backgroundColor: "#ffff00" }}>
            {m[0]}
          </mark>
        );
        last = m.index + m[0].length;
        // safety guard not strictly needed here since matches are > 0 length
        if (re.lastIndex === m.index) re.lastIndex++;
      }
      if (last < hay.length) out.push(hay.slice(last));
      return <span style={{ whiteSpace: "pre-wrap" }}>{out}</span>;
    } catch (e) {
      // Fallback to plain text if regex construction fails
      return <span style={{ whiteSpace: "pre-wrap" }}>{hay}</span>;
    }
  };

  // Render the content and insert the link only when necessary
  const renderContent = () => {
    if (!hasLink) return applyHighlighting(editedTxt);

    // Split text at `{link}` and insert clickable link
    const parts = editedTxt.split("{link}");

    return parts.map((part, index) => {
      if (index === parts.length - 1) {
        // Last part, return the remaining text (no link)
        return applyHighlighting(part);
      }

      return (
        <React.Fragment key={index}>
          {applyHighlighting(part)}
          <span className="link-hover" onClick={(e) => handleLinkClick(e)}>
            {hasLink}
          </span>
        </React.Fragment>
      );
    });
  };

  // Render the final component
  return (
    <span>
      <span style={{ color: "#ff0000" }}>
        {publishStatus === "republished"
          ? i18n.t("forum.EDITED_TEXT")
          : publishStatus === "irelevant"
          ? i18n.t("forum.IRRELAVENT_TEXT")
          : ""}{" "}
      </span>
      {renderContent()}
    </span>
  );
};

export default Highlighted;



// WEBPACK FOOTER //
// ./src/components/Highlighted.js